import { useMemo } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { useHostContext } from '@/context/HostContext.tsx';
import { useAgentTraining } from '@/store/agent-training';
import { AgentTrainingStep, TScrapingStatus } from '@/types/agent-training';

export const useCreatorStatus = () => {
	const { localization } = useHostContext();
	const { agentTrainingStep, scrapingStatus, isCustomerFormAllowed } =
		useAgentTraining(
			useShallow((s) => ({
				agentTrainingStep: s.agentTrainingStep,
				scrapingStatus: s.scrapingStatus,
				isCustomerFormAllowed: s.isCustomerFormAllowed
			}))
		);

	const isScrappingProcessStarted = scrapingStatus === TScrapingStatus.STARTED;
	const isScrappingProcessFinished =
		scrapingStatus === TScrapingStatus.FINISHED;

	const isOnboardingInProgress =
		agentTrainingStep === AgentTrainingStep.ContactAgreement ||
		agentTrainingStep === AgentTrainingStep.Loading;

	const isShowFinishedAnimationAndText = isCustomerFormAllowed
		? isOnboardingInProgress && isScrappingProcessFinished
		: isScrappingProcessFinished;

	const trainingStatusText = useMemo(() => {
		if (isShowFinishedAnimationAndText) {
			return localization.translate(
				'creator',
				'trainingProgressStatus.finished'
			);
		}

		if (isOnboardingInProgress) {
			return localization.translate(
				'creator',
				'trainingProgressStatus.progress'
			);
		}

		return localization.translate('creator', 'trainingProgressStatus.starting');
	}, [isShowFinishedAnimationAndText, isOnboardingInProgress, localization]);

	return {
		trainingStatusText,
		isScrappingProcessStarted,
		isShowFinishedAnimationAndText,
		isOnboardingInProgress
	};
};
